import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FaSignOutAlt, FaCode, FaBars, FaTimes, FaRobot } from 'react-icons/fa';
import Logo from '../logo.svg';
import './Navbar.css';

const Navbar = () => {
    const { user, firebaseUser, logout } = useAuth();
    const location = useLocation();

    console.log('🔗 Navbar: Rendering...', {
        path: location.pathname,
        hasUser: !!user,
        hasFirebaseUser: !!firebaseUser
    });

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // Hide Navbar in Editor to allow full screen layout
    if (location.pathname.startsWith('/room/')) {
        return null; // Editor has its own toolbar
    }

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const closeMenu = () => setIsMenuOpen(false);

    const isActive = (path) => location.pathname === path ? 'active' : '';

    const isLanding = location.pathname === '/';

    return (
        <nav className={`navbar ${isLanding ? 'navbar-transparent' : ''}`}>
            <Link to="/" className="navbar-brand" onClick={closeMenu}>
                <img src={Logo} alt="CodeConnect Logo" className="navbar-logo" style={{ width: '40px', height: '40px' }} />
                <span>CodeConnect</span>
            </Link>

            <button className="mobile-menu-toggle" onClick={toggleMenu}>
                {isMenuOpen ? <FaTimes /> : <FaBars />}
            </button>

            {/* Desktop & Mobile Menu Logic Combined for simplicity or split */}
            <div className={`navbar-links ${isMenuOpen ? 'mobile-menu' : ''}`}>
                {/* Mobile-only header duplicates could go here if needed, or just standard links */}

                {(user || firebaseUser) && (
                    <>
                        <Link to="/dashboard" className={`nav-link ${isActive('/dashboard')}`} onClick={closeMenu}>Dashboard</Link>
                        <Link to="/problems" className={`nav-link ${isActive('/problems')}`} onClick={closeMenu}>Problems</Link>
                        <Link to="/leaderboard" className={`nav-link ${isActive('/leaderboard')}`} onClick={closeMenu}>Leaderboard</Link>

                        <div className="nav-divider"></div>

                        <Link to="/debugging" className={`nav-link ${isActive('/debugging')}`} onClick={closeMenu}>Debugging</Link>
                        <Link to="/testing" className={`nav-link ${isActive('/testing')}`} onClick={closeMenu}>Testing</Link>
                        <Link to="/codegen" className={`nav-link ${isActive('/codegen')}`} onClick={closeMenu}>Code Gen</Link>
                        <Link to="/chat" className={`nav-link ${isActive('/chat')}`} onClick={closeMenu} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <FaRobot size={13} /> AI Chat
                        </Link>
                    </>
                )}

                <div className="navbar-auth">
                    {(user || firebaseUser) ? (
                        <>
                            <Link to="/profile" className="user-profile-link" onClick={closeMenu}>
                                <img
                                    src={(user && user.avatar) || (firebaseUser && firebaseUser.photoURL) || `https://ui-avatars.com/api/?name=${(user && user.username) || (firebaseUser && firebaseUser.displayName) || (firebaseUser && firebaseUser.email.split('@')[0])}`}
                                    alt="Avatar"
                                    className="user-avatar"
                                />
                                <span>{(user && user.username) || (firebaseUser && firebaseUser.displayName) || (firebaseUser && firebaseUser.email.split('@')[0])}</span>
                            </Link>
                            <button onClick={() => { logout(); closeMenu(); }} className="btn-logout">
                                <FaSignOutAlt /> Logout
                            </button>
                        </>
                    ) : (
                        <>
                            <Link to="/login" className="btn-login" onClick={closeMenu}>Login</Link>
                            <Link to="/signup" className="btn-signup" onClick={closeMenu}>Sign Up</Link>
                        </>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
